/**
 * Multi-room reservations: let a room booking hold several meeting rooms at once
 * (pick extra rooms from the map, one schedule covering all of them).
 *
 * Flip to `false` to disable the feature everywhere without removing the code.
 */
export const MULTI_ROOM_RESERVATION_ENABLED = true;

/**
 * Upper bound on the rooms a single reservation may hold. The API enforces no limit,
 * but every extra room multiplies the slots we post (one per room per attendee), so we
 * keep the payload — and the UI — bounded.
 */
export const MULTI_ROOM_RESERVATION_MAX_ROOMS = 20;
